import { ControlTemplate } from 'dac-web-ui';
import css from './cellSelection.module.css';
import html from './cellSelection.module.hbs';

export class CellSelection extends ControlTemplate {

	constructor( containerId ) {
		super();
		this.containerId = containerId;
		this._escEvent = null;
	}

	async show() {
		return new Promise(( resolve ) => {
			//add css
			let idcss = 'cellSelection';
			
			//remove
			let old = document.head.querySelector( '#' + idcss );
			if( old ) old.parentNode.removeChild( old );

			//add
			let styleSheet = document.createElement( 'style' );
			styleSheet.id = idcss;
			styleSheet.type = 'text/css';
			styleSheet.innerText = css;

			document.head.appendChild( styleSheet );

			//add html
			this.container = document.getElementById( this.containerId );
			const item = {
				rowTitle: 'ROW',
				columnTitle: 'COLUMN',
				startTitle: 'START',
				endTitle: 'END',
				cancelTitle: 'CANCEL',
				deselectTitle: 'DESELECT',
				selectTitle: 'SELECT',
				startRow: '',
				startColumn: '',
				endRow: '',
				endColumn: ''
			};
			if( this.container ) this._addHtml( this.container, item, html );
			this.#addEventHandlers( resolve );

			//focus row start
			const rowStart = document.querySelector('#CSInputStartRow');
			rowStart.focus();
			//rowStart.select();
		} );
	}

	#addEventHandlers( resolve ) {
		//on cancel click
		let add = document.querySelector('#CSButtonCancel');
		add.onclick = () => this.#close(resolve, false);
		let background = document.querySelector('#CSScreen');
		background.onclick = e => {
			if( e.target.id === 'CSScreen' )
				this.#close(resolve, false);
		};

		//on cancel click
		let deselect = document.querySelector('#CSButtonDeselect');
		deselect.onclick = () => this.#close(resolve, true, false);

		//on cancel click
		let select = document.querySelector('#CSButtonSelect');
		select.onclick = () => this.#close(resolve, true, true);

		const close = (resolve) => this.#close(resolve, false);

		this._escEvent = (e) => {
			if (e.key === 'Escape') close( resolve, false );
		};
		document.addEventListener( 'keydown', this._escEvent );
	}

	#close( resolve, response, select) {

		let result = {
			ok: response,
			select: select
		};

		if( response ) { Object.assign( result, this.#getResult() ); }		

		//remove css
		let idcss = 'cellSelection';
		let old = document.head.querySelector( '#' + idcss );
		if( old ) old.parentNode.removeChild( old );

		//remove html
		if( this.container ) this.container.innerHTML = '';

		//remove events
		document.removeEventListener( 'keydown', this._escEvent );
		this._escEvent = null;

		resolve( result );
	}

	#getResult() {
		let result = {};
		//get start row and column
		let srow, scol, erow, ecol;
		try {
			srow = parseInt( document.querySelector('#CSInputStartRow').value );
		} catch( e ) { srow = 1; }
		try {
			scol = parseInt( document.querySelector('#CSInputStartColumn').value );
		} catch( e ) { scol = 1; }
		try {
			erow = parseInt( document.querySelector('#CSInputEndRow').value );
		} catch( e ) { erow = 1; }
		try {
			ecol = parseInt( document.querySelector('#CSInputEndColumn').value );
		} catch( e ) { ecol = 1; }

		result = {
			start: {
				row: srow,
				column: scol
			},
			end: {
				row: erow,
				column: ecol
			}
		};

		return result;
	}
}